(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gant-collection-seo"]) return;
  try {
    
  class CollectionSeoExpander extends HTMLElement {
    #text = null;
    #toggle = null;
    #toggleLabel = null;
    #expanded = false;

    connectedCallback() {
      this.#text = this.querySelector('[data-ref="text"]');
      this.#toggle = this.querySelector('[data-ref="toggle"]');
      this.#toggleLabel = this.querySelector('[data-ref="toggleLabel"]');

      if (!this.#toggle) return;

      this.#toggle.addEventListener('click', this.#handleToggle);
    }

    #handleToggle = () => {
      this.#expanded = !this.#expanded;

      if (this.#expanded) {
        this.#text.classList.add('is-expanded');
        this.#toggle.setAttribute('aria-expanded', 'true');
        this.#toggleLabel.textContent = this.#toggle.dataset.labelLess || '';
      } else {
        this.#text.classList.remove('is-expanded');
        this.#toggle.setAttribute('aria-expanded', 'false');
        this.#toggleLabel.textContent = this.#toggle.dataset.labelMore || '';
      }
    };
  }

  customElements.define('collection-seo-expander', CollectionSeoExpander);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlight-multi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function centerSecondProduct(container) {
      var first = container.querySelector('.product-highlight-multi__product');
      if (!first) return;
      var cardWidth = first.offsetWidth;
      var containerWidth = container.offsetWidth;
      if (!cardWidth || !containerWidth) return;
      var target = cardWidth - (containerWidth - cardWidth) / 2;
      // Disable snap temporarily so the browser doesn't fight the programmatic scroll
      container.style.scrollSnapType = 'none';
      container.scrollLeft = target;
      requestAnimationFrame(function () {
        container.style.removeProperty('scroll-snap-type');
      });
    }

    function init() {
      if (window.innerWidth >= 722) return;
      document.querySelectorAll('.product-highlight-multi__products').forEach(centerSecondProduct);
    }

    // window.load guarantees CSS layout is fully computed (DOMContentLoaded is too early)
    window.addEventListener('load', init);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target.querySelector('[data-testid^="product-highlight-multi-"]')) return;
      requestAnimationFrame(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
